.audience-membership-stats {
    height: 498px;
    margin-right: 16px;
    width: 245px;
}
